<h3 mat-dialog-title>Upload Results</h3>
<mat-dialog-content class="mat-dialog-content-spacing-vertical">
  @for (cur of ipStats; track cur) {
    <div>
      @if (cur.successFiles.length > 0 || cur.failureFiles.length > 0) {
        <mat-expansion-panel expanded="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="title-text">
                <ip-icon [ipType]="cur.item.ipType"></ip-icon> {{ cur.item.ipType === 'Reference' ? 'Reference Library' : cur.item.identifier }}
              </span>
            </mat-panel-title>
            @if (cur.successFiles.length > 0) {
              <span class="success-badge" matTooltip="Success">{{cur.successFiles.length}}</span>
            }
            @if (cur.failureFiles.length > 0) {
              <span class="failure-badge" matTooltip="Failures">{{cur.failureFiles.length}}</span>
            }
          </mat-expansion-panel-header>
          <div>
            @if (cur.successFiles.length > 0) {
              <div>
                <strong>Successfully uploaded {{ cur.successFiles.length }} files:</strong>
                <mat-list>
                  @for (fileName of cur.successFiles; track fileName) {
                    <mat-list-item>
                      •&nbsp;&nbsp;{{ cleanAndTruncateFileName(fileName, 25) }}
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            }
            @if (cur.failureFiles.length > 0) {
              <mat-divider></mat-divider>
              <div>
                <strong>Failed to upload {{ cur.failureFiles.length }} files:</strong>
                <mat-list>
                  @for (fileName of cur.failureFiles; track fileName) {
                    <mat-list-item >
                      •&nbsp;&nbsp;{{ cleanAndTruncateFileName(fileName, 25) }}
                    </mat-list-item>
                  }
                </mat-list>
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-raised-button (click)="dialogRef.close()" color="primary">OK</button>
</mat-dialog-actions>